<template>
  <transition name="fade">
    <div class="login-popup" v-if="visible">
      <div class="popup-shadow" @click="hidePopup"></div>
      <div class="popup-container">
        <a href="javascript:;" class="popup-close" @click="hidePopup">
          <em class="icon"></em>
        </a>
        <img class="login-bg" v-if="loginBg" :src="loginBg" alt="login-bg" />
        <!-- <div class="login-title">
          {{ titleText }}
        </div> -->
        <div class="qrcode-login-wrap">
          <div class="qrcode-content">
            <div
              class="qrcode-box"
              v-if="qrStatus !== QRCodeStatus.INIT || qrCodeLoading"
            >
              <img
                v-if="qrCodeUrl || qrCodeLoading"
                :src="qrCodeUrl"
                alt="二維碼"
                class="qrcode-img"
              />
              <div v-if="qrCodeLoading" class="qrcode-loading">
                <div class="loading-icon"></div>
                <div class="scanned-text">{{ letter.v3ScanLoading }}</div>
              </div>
              <div
                v-if="qrStatus === QRCodeStatus.EXPIRED && !qrCodeLoading"
                class="qrcode-expired"
                @click="refreshQRCode"
              >
                <div class="scanned-text">{{ letter.v3ScanExpired }}</div>
                <div class="scanned-text">{{ letter.v3ScanRefreshClick }}</div>
                <div class="scanned-text">
                  <div class="scanned-icon"></div>
                  {{ letter.v3ScanRefresh }}
                </div>
              </div>
              <div
                v-if="qrStatus === QRCodeStatus.SCANNED"
                class="qrcode-scanned"
              >
                <div class="scanned-text">{{ letter.v3ScanSucc }}</div>
                <div class="scanned-text">{{ letter.v3ScanAuth }}</div>
              </div>
              <div
                v-if="qrStatus === QRCodeStatus.CONFIRMED"
                class="qrcode-confirmed"
              >
                <div class="scanned-text">{{ letter.v3ScanAuthSuccess }}</div>
                <div class="scanned-text">
                  {{ letter.v3ScanAuthSuccessTip }}
                </div>
              </div>
              <div
                v-if="qrStatus === QRCodeStatus.UNAUTHORIZED && !qrCodeLoading"
                class="qrcode-expired"
                @click="refreshQRCode"
              >
                <div class="scanned-text">{{ letter.v3ScanUnauthorized }}</div>
                <div class="scanned-text">{{ letter.v3ScanRefreshTip }}</div>
                <div class="scanned-text">
                  <div class="scanned-icon"></div>
                  {{ letter.v3ScanRefresh }}
                </div>
              </div>
            </div>
            <div class="function-wrap">
              <div class="tips">{{ letter.v3ScanRefreshTip2 }}</div>
              <div class="btn-wrap">
                <div
                  class="btn"
                  :class="{ disabled: qrCodeLoading }"
                  @click="!qrCodeLoading && refreshQRCode()"
                >
                  <span class="icon"></span> {{ letter.v3ScanRefresh }}
                </div>
                <div class="divider">|</div>
                <div class="btn">
                  {{ letter.v3ScanGuide }}
                  <div class="scan-guide"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div></div
  ></transition>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import qrCodeLogin from '@mixins/officialTopup/qrCodeLogin';
export default {
  name: 'QrcodeLoginPopup',
  mixins: [qrCodeLogin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      picList: state => state.page.picList
    }),
    loginBg() {
      return this.picList?.loginbanner || '';
    },
    titleText() {
      let text = this.letter.login;
      return text;
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗打开时初始化二维码
        this.initQRCodeLogin();
      } else {
        // 弹窗关闭时清理资源
        this.cleanupQRCode();
      }
    }
  },
  methods: {
    hidePopup() {
      this.$emit('update:visible', false);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/officialTopup.scss';
@import '@assets/scss/officialTopup/_dimen.scss';
.login-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}
.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
}
.login-bg {
  width: 100%;
  border-radius: 20px 20px 0 0;
}

.login-title {
  padding: 40px 40px 50px;
  text-align: center;
  line-height: 1.2;
  font-size: 28px;
  margin: 0;
  border-radius: 20px;
  font-weight: bold;
  color: #333333;
}

.popup-close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: -40px;
  top: -40px;
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  .icon {
    display: block;
    background: url($commonImg + 'close.png') no-repeat;
    width: 28px;
    height: 28px;
  }
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
    ::v-deep .uid-token-content {
      width: 100%;
    }
    ::v-deep .third-login .space .line {
      width: 368px;
    }
  }
  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }
}

.qrcode-login-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  .qrcode-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 275px;
    margin-top: 20px;
    .qrcode-box {
      width: 290px;
      height: 290px;
      position: relative;
      background-color: #fff;
      border-radius: 15px;
      // border: 1px solid rgba(178, 191, 226, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
      overflow: hidden;
      .qrcode-img {
        width: 260px;
        height: 260px;
        object-fit: contain;
      }
      .qrcode-expired,
      .qrcode-scanned,
      .qrcode-confirmed,
      .qrcode-loading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.75);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
      }
      .qrcode-expired {
        cursor: pointer;
        &:hover {
          .refresh-btn {
            background-color: #5c86d7;
            color: #fff;
          }
        }
      }
      .qrcode-loading {
        .loading-icon {
          width: 60px;
          height: 60px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
          margin-bottom: 15px;
        }
      }
      .scanned-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url($commonLoginImg + 'code_refresh_white.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
        cursor: pointer;
      }
      .scanned-text {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #fff;
        margin-bottom: 10px;
      }
    }
    .function-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      margin-bottom: 20px;
      .tips {
        text-align: center;
        font-size: 18px;
        line-height: 1.4;
        color: #9ea7ba;
        margin-bottom: 24px;
      }
      .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        .btn {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #5c86d7;
          cursor: pointer;
          z-index: 10;
          transition: opacity 0.3s;
          &:hover {
            .scan-guide {
              display: block;
            }
          }
          &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
        .scan-guide {
          display: none;
          position: absolute;
          top: -490px;
          left: -230px;
          width: 527px;
          height: 491px;
          background: url($commonLoginImg + 'code_guide.png') no-repeat;
          background-size: 100% 100%;
        }

        .divider {
          margin: 0 15px;
          font-size: 16px;
          color: #000;
        }
        .icon {
          width: 20px;
          height: 20px;
          background: url($commonLoginImg + 'code_refresh.png') no-repeat;
          background-size: 100% 100%;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
